import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const { portfolioData } = useSelector((state) => state.root);
  const { intro } = portfolioData;

  // console.log(intro);
  return (
    <div className=" fixed flex justify-center bg-primary dark:bg-bg-dark items-center  bottom-0 left-0 sm:pb-5 px-8 sm:static">
      <div className="   flex-col ">
        <div className="flex flex-col gap-2 text-tertiary/35  text-xl sm:flex-row">
          {intro.github && (
            <Link to={intro.github} target="_blank">
              <i class="ri-github-fill "></i>
            </Link>
          )}
          {intro.facebook && (
            <Link to={intro.facebook} target="_blank">
              <i className="ri-facebook-circle-line"></i>
            </Link>
          )}
          {intro.linkdein && (
            <Link to={intro.linkdein} target="_blank">
              <i class="ri-linkedin-box-fill"></i>
            </Link>
          )}
          {intro.instagram && (
            <Link to={intro.instagram} target="_blank">
              <i class="ri-instagram-line"></i>
            </Link>
          )}
          {intro.whatsapp && (
            <Link to={intro.whatsapp} target="_blank">
              <i class="ri-whatsapp-line"></i>
            </Link>
          )}
          <div className="w-[2px] h-32 mx-auto bg-tertiary/35 sm:hidden"></div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
